import { createContext, useContext } from 'react';
export const FileViewerContext = createContext({
    file: undefined,
    openOptions: undefined,
    openRequestId: 0,
    canOpenFiles: false,
    openFile: () => { },
    closeViewer: () => { },
    isCurrentFile: () => false,
    markFileLoaded: () => { },
    getLoadedFile: () => undefined,
    doViewerAction: () => { },
    isViewerOpen: false,
    setViewerDispatch: () => { },
});
FileViewerContext.displayName = 'FileViewerContext';
export function useFileViewerContext() {
    return useContext(FileViewerContext);
}
//# sourceMappingURL=fileViewerTypes.js.map